<template>
  <div v-if="items.length" class="items">
    <section>
      <v-container class="overflow-hidden container-large">
        <TitleWidget small>
          {{ upTitle }}
        </TitleWidget>
        <TitleWidget>
          {{ title }}
        </TitleWidget>
        <v-row class="mt-2 grid-list" justify="center">
          <template v-for="(item, keyItems) in items">
            <v-col :key="keyItems" cols="6" md="4" lg="3">
              <CourseCard v-bind="item" />
            </v-col>
          </template>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import CourseCard from "../cards/CourseCard.vue";
import { formatToURL } from "../../utils/formatToURL";

const _config = {
  mod: "courses",
  path: "/cursos",
};

const _data = {
  upTitle: "Conheça",
  title: "Nossos Cursos",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(({ img, title }) => ({
        img: img.featured,
        title,
        to: `${_config.path}/${formatToURL(title)}`,
      }));
    },
  },
  created() {
    this.$rest(_config.mod).get();
  },
  components: {
    TitleWidget,
    CourseCard,
  },
};
</script>

<style lang="scss" scoped>
.items {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  .grid-list {
    gap: 0px 0;
  }
}
</style>
